
<conditional-display-modal
    :conditional-rule-options="conditionalRuleOptions"
    disallow-multiple-sets
    :hide-preview="hidePreview"
    @toggle-modal="emitHideModal"
    v-bind="{...$attrs, ...$props}"
>
  <template #rule-options="{ rule }">
    <button type="button" @click="() => deleteRule(rule)" class="btn-icon grey sm" :disabled="preventDelete" :style="preventDelete ? 'display: none' : null">
      <span class="sr-only">Delete Item</span>
      <icon class="times"></icon>
    </button>
  </template>
</conditional-display-modal>
